import RecordBase from './../tools/RecordBase';
import app from '../base/api';

class Usuario extends RecordBase {

  constructor () {
    super();
    this.state.cls = 'usuarios';
    this.title = 'Usuario';
  }

  fetchData = async () => {
    let data = await app.get('/api/tables/usuarios/' + this.state.id);
    data.Password = '';
    this.setState({record: data})
  }
  /*Tarea GDM-708 - Inicio */
  /*save = async () => {
    var form = new FormData();
    form.append('data', JSON.stringify(this.state.record));
    let data = await app.post('/api/tables/usuarios/', form, {});
    if (data) {
      data.Password = '';
      this.setState({record: data, message: 'Registro Grabado'})
    }
  }*/
  /*Tarea GDM-708 - Fin */

}

export default Usuario;